import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { exportWorkControlFailed, exportWorkControlSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, LOADING_DELAY } from '../../../configs';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';

export default function* exportWorkControl(action) {
  try {
    const filter = action.payload;
    let pool = {};
    if (typeof filter === 'object' && Object.keys(filter).length) {
      pool = addFilterQueryWithCondition(filter, pool);
    }
    const url = `${BACKEND_URL}/resources/activity-logs/export`;
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.blob();
      yield put(exportWorkControlSuccessful());
      yield call(resolveActionPromise(action, data));
    } else {
      const data = yield dataResponse.json();
      yield put(exportWorkControlFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(exportWorkControlFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
